/** Atomically closes the oldest open interval and starts its successor across tabs. */
export async function rotateCatchupEnvelope(database, { now = Date.now } = {}) {
  return database.transaction('rw', database._catchup_envelopes, async () => {
    const envelopes = await database._catchup_envelopes.where('status').equals('open').toArray();
    const timestamp = now();
    envelopes.sort((a, b) => a.since - b.since);
    const oldest = envelopes[0];
    if (oldest) {
      await database._catchup_envelopes.put({ ...oldest, status: 'ready', until: timestamp });
      await database._catchup_envelopes.where('status').equals('open').delete();
    }
    return database._catchup_envelopes.add({ status: 'open', since: timestamp });
  });
}

/** Ensures one open interval without racing a concurrent tab or keepalive. */
export async function ensureCatchupEnvelope(database, { bump = false, now = Date.now } = {}) {
  return database.transaction('rw', database._catchup_envelopes, async () => {
    const open = await database._catchup_envelopes.where('status').equals('open').count();
    const timestamp = now();
    if (open === 0) return database._catchup_envelopes.add({ status: 'open', since: timestamp });
    if (bump) await database._catchup_envelopes.where('status').equals('open').modify({ since: timestamp });
  });
}
